import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useQueryParamValue } from '#src/app/shared/hooks/location';

type Result = ModelHookResult<
	{
		url: string;
	},
	{
		trackClick: (item: 'continue' | 'back') => void;
	}
>;

export function usePageBody(): Result {
	const url = useQueryParamValue('to') || '/';
	const track = useTracking();

	return {
		data: {
			url,
		},
		actions: {
			trackClick: useCallback(
				(item) => {
					void track(`off_site_redirect_${item}_click`);
				},
				[track],
			),
		},
	};
}
